export default "__VITE_ASSET__BS0EOKR1__"